/**
 * Utility functions for handling URLs
 */

/**
 * Formats a URL to ensure it has a proper protocol
 * @param url - The URL to format
 * @returns The formatted URL with proper protocol
 */
export const formatWebsiteUrl = (url: string): string => {
  if (!url) return '';
  
  // Remove any leading/trailing whitespace
  const trimmedUrl = url.trim();
  
  // If it already has a protocol, return as is
  if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
    return trimmedUrl;
  }
  
  // If it starts with www., add https://
  if (trimmedUrl.startsWith('www.')) {
    return `https://${trimmedUrl}`;
  }
  
  // For other cases, add https://
  return `https://${trimmedUrl}`;
};

/**
 * Displays a URL in a user-friendly format
 * @param url - The URL to display
 * @returns The display version of the URL
 */
export const getDisplayUrl = (url: string): string => {
  if (!url) return '';
  
  const trimmedUrl = url.trim();
  
  // Remove protocol for display if present
  if (trimmedUrl.startsWith('https://')) {
    return trimmedUrl.substring(8);
  }
  if (trimmedUrl.startsWith('http://')) {
    return trimmedUrl.substring(7);
  }
  
  return trimmedUrl;
}; 